import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, Link, useParams } from "react-router-dom";

const Footer = () => {
  return (
    <div>
        <footer id="eskimo-footer">
            <div className="container">
                <div className="row eskimo-footer-wrapper">
                    <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                        <h5 className="eskimo-title-with-border"><span>About Me</span></h5>
                        <p>Trusted by thousands of customers, my unique themes and plugins help you make beautiful responsive web sites with ease.</p>
                        <p><Link to={`/`} className="btn btn-default">Read More</Link></p>
                    </div>
                    <div className="col-12 col-lg-6">
                        <h5 className="eskimo-title-with-border"><span>Newsletter</span></h5>
                        <form method="post" action="">
                            <label>Subscribe to our mailing list!</label>
                            <div className="input-group">
                                <input type="email" className="form-control" name="EMAIL" placeholder="Your email address" required />
                                <div className="input-group-append"> 
                                    <input type="button" value="Sign up"  className="btn btn-default" />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="eskimo-footer-credits">
                    <p>
                        Made with love by <a href="http://tanzildeveloper.in/" target="_blank">Tanzil Dev</a>
                    </p>
                </div>
            </div>
        </footer>
    </div>
  )
}

export default Footer